// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Site role model
*/
export class SiteBillingCodeModel {
    /**
    * @description Billing Code
    */
    'code'?: string | null;
    /**
    * @description Billing Code description
    */
    'description'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteBillingCodeModel>> = [
        {
            "name":     "code",
            "baseName": "code",
            "type":     "string"
        },
        {
            "name":     "description",
            "baseName": "description",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return SiteBillingCodeModel.attributeTypeMap;
    }
}
